import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Heart from 'react-animated-heart'

function Items(props) {

  const [Good, setGoods] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setGoods(props.items)
    // ////console.log(props.items)

  }, [props.items])


  const handleClick = (e) => {
    const itemDetails = {
      ...e,
      name: e.ItemName,
      Price: e.sellingPrice
    };
    props.addToBill(itemDetails);
  }

  const [isClick, setClick] = useState(false);
  const [newItem, setNewItem] = useState([])
  const [change, setChange] = useState(null)


  useEffect(() => {

    if (change != null) {

      const data = {
        id: change.ItemID,
        fav: (change.isfavourite === 0 ? 1 : 0)
      }

      // ////console.log(data)

      setLoading(true)


      axios.put("https://serverukautotech.ccsoftwares.com/Item/addToFavourite", data).then((res) => {
        ////console.log(res)
        props.trig(Math.random())
      }).catch(e => {
        ////console.log(e)
      })
    }

  }, [change, props])



  const setFavourite = async (e) => {
    // //console.log(e)

    setChange(e)
  }

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', height: '65vh', justifyContent: 'left' }}>
      {Good.map((item, index) => (
        <>
          <div key={index} style={{ width: '160px', backgroundColor: 'white', margin: 5 }}>
            <div >
              <div style={{ display: 'block', border: '1px solid #ccc', backgroundColor: 'white', borderRadius: 5 }}>
                <div style={{ marginBottom: -40, marginTop: -30, marginLeft: -30, display: 'relative' }}>

                  <Heart isClick={item.isfavourite} onClick={() => setFavourite(item)} />

                </div>
                <div onClick={() => { handleClick(item) }} style={{ border: '1px solid #ccc', padding: '10px', height: '180px', borderRadius: 5, display: 'flex', alignItems: 'center', flexDirection: 'column', backgroundColor: 'white', justifyContent: 'space-around' }}>

                  <img src={'https://serverukautotech.ccsoftwares.com/Assets/Items/' + item.ItemImage} style={{ objectFit: 'fill', width: 100, height: 100, borderRadius: 20 }} alt='' draggable={false}></img>

                  {item.ItemCategoryID === 5022 ? (<>
                  {/* <div style={{ fontWeight: 'bold',fontSize : '10px' }}>Enter Custom Value</div> */}
                  
                  </>) : (<>
                  <div style={{ fontWeight: 'bold' }}>Rs.{item.sellingPrice}</div>
                  
                  </>)}
                  {item.ItemName.length < 10 ? (<>
                    <div style={{ fontWeight: 'bold', fontSize: 18 }}>{item.ItemName}</div>
                  </>) : (<>
                    <div style={{ fontWeight: 'bold', fontSize: 10 }}>{item.ItemName}</div>
                  </>)}
                </div>
              </div>
            </div>
          </div>
        </>
      ))}
    </div>

  )
}

export default Items
